import {
    UsageCostAugmentedEntry,
    UsageCostAugmentedEntryFlat,
    UsageCostEntry,
    UsageCostEntryFlat,
} from '../hooks'

export const flattenUsageCostAugmentedEntry: (
    usageCost: UsageCostAugmentedEntry
) => UsageCostAugmentedEntryFlat = (usageCost) => ({
    ...flattenUsageCostEntry(usageCost),
    date: usageCost.date,
    formattedDate: usageCost.formattedDate,
    reportedUsns: usageCost.reportedUsns,
})

export const flattenUsageCostEntry: (
    usageCost: UsageCostEntry
) => UsageCostEntryFlat = (usageCost) => ({
    usage_commodityUsage: usageCost.usage.commodityUsage,
    usage_baselineUsage: usageCost.usage.baselineUsage,
    usage_budget: usageCost.usage.budget,
    usage_transportUsage: usageCost.usage.transportUsage,
    usage_weatherNormalized: usageCost.usage.weatherNormalized,
    usage_unit: usageCost.usage.unit,

    cost_totalInvoiced: usageCost.cost.totalInvoiced,

    cost_commodity_totalCommodityCost:
        usageCost.cost.commodity?.totalCommodityCost,
    cost_commodity_supply: usageCost.cost.commodity?.supply,
    cost_commodity_transmission: usageCost.cost.commodity?.transmission,
    cost_commodity_capacity: usageCost.cost.commodity?.capacity,

    cost_transport_totalTransportCost:
        usageCost.cost.transport?.totalTransportCost,
    cost_transport_tariff: usageCost.cost.transport?.tariff,
    cost_transport_4cp4ncp: usageCost.cost.transport?.['4cp4ncp'],
    cost_transport_billingDemand: usageCost.cost.transport?.billingDemand,

    cost_taxes: usageCost.cost.taxes,
    cost_other: usageCost.cost.other,
    cost_baselineCost: usageCost.cost.baselineCost,
    cost_budget: usageCost.cost.budget,
    cost_unit: usageCost.cost.unit,

    demand_actual: usageCost.demand.actual,
    demand_billing: usageCost.demand.billing,
    demand_unit: usageCost.demand.unit,
})
